import { BrowserRouter as Router, Switch, Route} from "react-router-dom";
import './App.css';
import Home from './Pages/Index';
import Catering from "./Pages/Catering"
import Event from "./Pages/Event";
import Wedding from "./Pages/Wedding";
import Cars from "./Pages/Cars";
import Service from "./Pages/Service";
import Decore from "./Pages/Decore";
import OmOss from "./Pages/OmOss";
import Consultant from './Pages/Consultant'
import Breakfast from './Pages/MenuPages/Breakfast';
import Lunch from "./Pages/MenuPages/Lunch";
import MenuSka from './Pages/MenuPages/MenuSka';
import MenuJap from './Pages/MenuPages/MenuJap';
import MenuMex from './Pages/MenuPages/MenuMex';
import MenuGre from './Pages/MenuPages/MenuGre';
import MenuLeb from './Pages/MenuPages/MenuLeb';
import MenuVie from './Pages/MenuPages/MenuVie';
import MenuTha from './Pages/MenuPages/MenuTha';
import MenuIta from './Pages/MenuPages/MenuIta';
import MenuInd from './Pages/MenuPages/MenuInd';
import MenuFra from './Pages/MenuPages/MenuFra';
import MenuPer from './Pages/MenuPages/MenuPer';
import MenuPeru from './Pages/MenuPages/MenuPeru';

function App() {
  return (
    <Router>  
      <Switch>   
        <Route path='/' component={Home} exact />
        <Route path='/catering' component={Catering} exact />
        <Route path='/wedding' component={Wedding} exact />
        <Route path='/cars' component={Cars} exact />
        <Route path='/event' component={Event} exact />
        <Route path='/service' component={Service} exact />
        <Route path='/decore' component={Decore} exact />
        <Route path='/about' component={OmOss} exact />
        <Route path='/consultant' component={Consultant} exact />
        <Route path='/breakfast' component={Breakfast} exact />
        <Route path='/lunch' component={Lunch} exact />
        <Route path='/menuSka' component={MenuSka} exact />
        <Route path='/menuJap' component={MenuJap} exact />
        <Route path='/menuMex' component={MenuMex} exact />
        <Route path='/menuGre' component={MenuGre} exact />
        <Route path='/menuLeb' component={MenuLeb} exact />
        <Route path='/menuVie' component={MenuVie} exact />
        <Route path='/menuTha' component={MenuTha} exact />
        <Route path='/menuIta' component={MenuIta} exact />
        <Route path='/menuInd' component={MenuInd} exact />
        <Route path='/menuFra' component={MenuFra} exact />
        <Route path='/menuPer' component={MenuPer} exact />
        <Route path='/menuPeru' component={MenuPeru} exact />
      </Switch>
      
    </Router>
  );
}

export default App;